<template>
  <IconField>
    <InputIcon>
      <AppIcon name="regular-magnifying-glass" />
    </InputIcon>
    <AutoComplete
      class="h-9 w-full text-sm transition-[width,max-width] duration-200 ease-in-out [&_input]:rounded-full"
      ref="autoCompleteRef"
      v-bind="attrs_forwarded"
      :pt="pt_merged"
      :modelValue="modelValue"
      @update:modelValue="$emit('update:modelValue', $event)"
    >
      <template
        v-for="(_, slot) in $slots"
        #[slot]="scope"
      >
        <slot
          :name="slot"
          v-bind="scope"
        />
      </template>
    </AutoComplete>
  </IconField>
</template>

<script setup>
// Typeahead search. Same shell as SearchInput.vue (pill input, leading magnifying glass); the pill
// goes on the inner input because AutoComplete's own class lands on its wrapper.
import { computed, ref, useAttrs } from 'vue';
import AutoComplete from 'primevue/autocomplete';

defineOptions({ inheritAttrs: false });

const attrs = useAttrs();

const attrs_forwarded = computed(() => {
  const { pt, 'data-test': data_test_value, ...attrs_next } = attrs;
  return attrs_next;
});

const pt_merged = computed(() => {
  const pt_user = attrs.pt;
  const data_test_value = attrs['data-test'];

  if (!data_test_value) return pt_user;
  if (!pt_user) {
    return { pcInputText: { root: { 'data-test': data_test_value } } };
  }
  if (typeof pt_user !== 'object' || Array.isArray(pt_user)) return pt_user;

  const pcInputText = { ...(pt_user.pcInputText || {}) };
  const root = { ...(pcInputText.root || {}) };

  pcInputText.root = 'data-test' in root ? root : { ...root, 'data-test': data_test_value };
  return { ...pt_user, pcInputText };
});

defineProps({
  modelValue: {
    type: [String, Object],
    default: null,
  },
});

defineEmits(['update:modelValue']);

const autoCompleteRef = ref(null);

const focus = () => {
  const auto_complete = autoCompleteRef.value;
  if (!auto_complete) return;
  if (typeof auto_complete.focus === 'function') return auto_complete.focus();
  auto_complete.$el.querySelector('input').focus();
};

defineExpose({ focus });
</script>
